<template>
  <Notify
    src="@/static/icon-unsubscribe.png"
    title="Successfully"
    desc="Unsubscribe auto renew package successfully. Thank!"
    typeclass="success"
  />
</template>

<script src="./index.js" ></script>

<style src="./index.scss" lang="scss" scoped> </style>
